type AddOnSectionLike<TMenuObject extends { _id: string }> = {
  options?: Array<{
    option?: TMenuObject | null;
  } | null> | null;
};

type CartEntryLike = {
  _id?: string;
  id?: string;
  isDonation?: boolean;
  price?:
    | number
    | {
        amount?: number;
      }
    | null;
};

export const isMenuObjectInAddOnSections = <TMenuObject extends { _id: string }>(
  menuObjectId: string,
  sections: AddOnSectionLike<TMenuObject>[]
) => {
  return sections.some(section =>
    (section.options ?? []).some(option => option?.option?._id === menuObjectId)
  );
};

export const flattenAddOnSectionsToMenuObjects = <TMenuObject extends { _id: string }>(
  sections: AddOnSectionLike<TMenuObject>[]
): TMenuObject[] => {
  const seenMenuObjectIds = new Set<string>();

  return sections.flatMap(section =>
    (section.options ?? []).flatMap(option => {
      const menuObject = option?.option;

      if (!menuObject || seenMenuObjectIds.has(menuObject._id)) {
        return [];
      }

      seenMenuObjectIds.add(menuObject._id);
      return [menuObject];
    })
  );
};
const getCartEntryId = (entry: CartEntryLike) => entry.id ?? entry._id ?? '';
const getCartEntryAmount = (entry: CartEntryLike) => {
  if (typeof entry.price === 'number') {
    return entry.price;
  }

  return entry.price?.amount ?? 0;
};

export const cartHasLegacyOrderableEntries = (cartEntries: CartEntryLike[]) => {
  return cartEntries.some(entry => !entry.isDonation);
};

export const isLegacyCondimentsOnlyCart = <TMenuObject extends { _id: string }>(
  cartEntries: CartEntryLike[],
  sections: AddOnSectionLike<TMenuObject>[],
  ignoredEntryIds: Iterable<string> = []
) => {
  const ignoredEntryIdsSet = new Set(ignoredEntryIds);
  const relevantEntries = cartEntries.filter(entry => {
    if (entry.isDonation) {
      return false;
    }

    return !ignoredEntryIdsSet.has(getCartEntryId(entry));
  });

  if (!relevantEntries.length) {
    return false;
  }

  return relevantEntries.every(
    entry =>
      isMenuObjectInAddOnSections(getCartEntryId(entry), sections) && getCartEntryAmount(entry) <= 0
  );
};
